// The loan file's fees (`le_fees`) are the one fee source (ticket 192, grill 186 D8).
// Mirrors backend/loan_fees.py: which sections are line items, and when a loan "has fees".

// [LE letter, le_fees list field, heading]
export const LINE_SECTIONS = [
  ['A', 'origination_charges', 'A. Origination Charges'],
  ['B', 'services_no_shop', 'B. Services You Cannot Shop For'],
  ['C', 'services_can_shop', 'C. Services You Can Shop For'],
  ['E', 'taxes_govt', 'E. Taxes and Other Government Fees'],
  ['H', 'other', 'H. Other'],
];

// [label, months field, monthly field]
export const PREPAID_ROWS = [
  ['Homeowner\'s insurance', 'prepaid_hoi_months', 'prepaid_hoi_monthly'],
  ['Mortgage insurance', 'prepaid_mi_months', 'prepaid_mi_monthly'],
  ['Property taxes', 'prepaid_property_tax_months', 'prepaid_property_tax_monthly'],
];
// FHA, VA and USDA: their MI premiums never count toward QM points and fees.
export const GOVERNMENT_PROGRAMS = ['fha', 'va', 'usda'];

// Mirrors qm_points_fees.is_mortgage_insurance (ticket 258): a Section B line is a
// mortgage insurance premium when ticked MI, else when its name says so.
const MI_NAME = /\bmortgage\s+ins|\bmtg\.?\s+ins|\b(?:b?p)?mi\b|\bu?f?mip\b/i;
const MI_NAME_NOT = /\bcert|\blender[\s-]*paid/i;
export function isMortgageInsurance(field, line) {
  if (field !== 'services_no_shop') return false;
  if (line.mortgage_insurance === true || line.mortgage_insurance === false) return line.mortgage_insurance;
  const name = line.name || '';
  return MI_NAME.test(name) && !MI_NAME_NOT.test(name);
}

// Mortgage insurance paid at closing: Section F prepaid MI or a borrower-paid B MI line.
export function hasMiAtClosing(fees) {
  const f = fees || {};
  if (Number(f.prepaid_mi_months) * Number(f.prepaid_mi_monthly) > 0) return true;
  return (f.services_no_shop || []).some((l) => isMortgageInsurance('services_no_shop', l) && l.borrower_paid !== false && Number(l.amount) > 0);
}
export const ESCROW_ROWS = [
  ['Homeowner\'s insurance', 'escrow_hoi_months', 'escrow_hoi_monthly'],
  ['Mortgage insurance', 'escrow_mi_months', 'escrow_mi_monthly'],
  ['Property taxes', 'escrow_property_tax_months', 'escrow_property_tax_monthly'],
];

const AMOUNT_FIELDS = [
  'prepaid_interest_per_day',
  ...PREPAID_ROWS.map(([, , monthly]) => monthly),
  ...ESCROW_ROWS.map(([, , monthly]) => monthly),
  'lender_credit',
];

// True once a line item or a prepaid / escrow / credit amount is entered; the
// model's default month counts alone do not count.
export function hasFees(fees) {
  const f = fees || {};
  if (LINE_SECTIONS.some(([, field]) => (f[field] || []).length)) return true;
  return AMOUNT_FIELDS.some((k) => Number(f[k]) > 0);
}

// QM points and fees (ticket 192 D9). Mirrors backend/qm_points_fees.py: Section A
// paid by the borrower counts unless the line says otherwise; other sections count
// only when ticked.
export function countsTowardQm(field, line) {
  if (line.points_and_fees === true || line.points_and_fees === false) return line.points_and_fees;
  return field === 'origination_charges' && line.borrower_paid !== false;
}
